import React from 'react';
import {Col, Row, Container} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import Lottie from 'react-lottie';
import PaperPlane from '../../../animations/paperPlane.json';
import ThemedLottie from '../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../utilities/theme/ThemeColorEnum';
import './actionIsNotAllowedPopupContent.scss';
import iconCallBusiness from './images/icon-call-business/icons-call-phone.svg';

const ActionIsNotAllowedPopupContent = (props) => {
  return (
    <Container>
      <Row>
        <Col>
          <span className='bold d-block popup-component-headline bold' dangerouslySetInnerHTML={{__html: props.title}} />
        </Col>
      </Row>
      <Row>
        <Col className='image'>
          {/* <Lottie options={{animationData: PaperPlane, loop: false}} width={250} /> */}
          <ThemedLottie animationData={PaperPlane} color={ThemeColorEnum.PRIMARY} loop={false} width={250} />
        </Col>
      </Row>
      <Col>
        <span className='bold d-block popup-description-component bold' dangerouslySetInnerHTML={{__html: props.description}} />
      </Col>
      {isMobile ? (
        <Row>
          <Col className='popup-callback-container-mobile'>
            <div className={`popup-callback-phone-container-mobile`} onClick={() => props.onclick && props.onclick()}>
              <a href={`tel:${Config.businessCallNumber}`} className={`btn popup-callback-call-btn d-block w-100 bold`}>
                {`חיוג  ${Config.businessCallNumber.replace('*', '').concat('*')} לעדכון ההרשאה`}
              </a>
            </div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col className='popup-callback-container'>
            <div className={`popup-callback-phone-container`}>
              <div className='callBack-description-text'> {`לקבלת השירות שלנו`} </div>
              <div className='d-flex justify-content-center'>
                <div className={`popup-callback-phone`} style={{ backgroundImage: iconCallBusiness.bg() }}></div>
                <div className='bold callBack-call-text'> {`חייגו למספר  ${Config.businessCallNumber.replace('*', '').concat('*')}`} </div>
              </div>
            </div>
          </Col>
        </Row>
      )}
    </Container>
  );
};
export default ActionIsNotAllowedPopupContent;
